<template>
  <validation-provider
    :vid="id"
    :name="id"
    :rules="validations"
    v-slot="{ errors }"
  >
    <v-textarea
      counter
      :label="label"
      :error-messages="errors"
      :placeholder="placeholder"
      :disabled="disabled"
      :rows="rows"
      v-model="inputValue"
      @blur="blur"
    />
  </validation-provider>
</template>

<script>
import InputMixin from './InputMixin'

export default {
  mixins: [InputMixin],
  props: {
    rows: {
      type: Number,
      required: false,
      default: 4,
    },
  },
}
</script>
